/* tslint:disable */
/* eslint-disable */
/**
 * Pet Profile A Service
 * Pet Profile A Layer Service For more information or information on how this data maps to the kryios data see [here](https://chewyinc.atlassian.net/wiki/spaces/MPROD/pages/1957927091/Pet+Property+to+Data+Mapping)
 *
 * The version of the OpenAPI document: 1.0
 * Contact: DL-IT_Pet_Profile@chewy.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import {
    GenderAndSterilizationModel,
    instanceOfGenderAndSterilizationModel,
    GenderAndSterilizationModelFromJSON,
    GenderAndSterilizationModelFromJSONTyped,
    GenderAndSterilizationModelToJSON,
} from './GenderAndSterilizationModel';

/**
 * @type PetFormFieldsValuesInnerModel
 * 
 * @export
 */
export type PetFormFieldsValuesInnerModel = { type: 'GenderAndSterilization' } & GenderAndSterilizationModel;

export function PetFormFieldsValuesInnerModelFromJSON(json: any): PetFormFieldsValuesInnerModel {
    return PetFormFieldsValuesInnerModelFromJSONTyped(json, false);
}

export function PetFormFieldsValuesInnerModelFromJSONTyped(json: any, ignoreDiscriminator: boolean): PetFormFieldsValuesInnerModel {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    switch (json['type']) {
        case 'GenderAndSterilization':
            return {...GenderAndSterilizationModelFromJSONTyped(json, true), type: 'GenderAndSterilization'};
        default:
            throw new Error(`No variant of PetFormFieldsValuesInnerModel exists with 'type=${json['type']}'`);
    }
}

export function PetFormFieldsValuesInnerModelToJSON(value?: PetFormFieldsValuesInnerModel | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    switch (value['type']) {
        case 'GenderAndSterilization':
            return GenderAndSterilizationModelToJSON(value);
        default:
            throw new Error(`No variant of PetFormFieldsValuesInnerModel exists with 'type=${value['type']}'`);
    }

}

